var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeelineProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11ZM12 13C15.0376 13 17.5 10.5376 17.5 7.5C17.5 4.46243 15.0376 2 12 2C8.96243 2 6.5 4.46243 6.5 7.5C6.5 10.5376 8.96243 13 12 13Z",
    fill: "#191C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C8.96243 16 6.5 18.4624 6.5 21.5H4.5C4.5 17.3579 7.85786 14 12 14C16.1421 14 19.5 17.3579 19.5 21.5H17.5C17.5 18.4624 15.0376 16 12 16Z",
    fill: "#191C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeelineProfile);
export default __webpack_public_path__ + "static/media/beeline_profile.5bd267b4b858f453d8da829bd586927f.svg";
export { ForwardRef as ReactComponent };